if (!customElements.get('celociel-mix-bundle')) {
  customElements.define('celociel-mix-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
      this.buttons = Array.from(this.querySelectorAll('.tiered-option'));
      this.form = document.getElementById(this.dataset.formId);
      this.submit = this.form?.querySelector('[type="submit"]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP'});
      this.addEventListener('click', event => {
        const button = event.target.closest('.tiered-option');
        if (button && !button.disabled) this.activate(button);
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-bundle-option]')) {
          event.stopPropagation();
          this.update();
        }
      });
      this.onFormData = event => {
        const items = this.getItems();
        if (!items.length) return;
        event.formData.delete('id');
        event.formData.delete('quantity');
        items.forEach((item,index) => {
          event.formData.set('items[' + index + '][id]', item.id);
          event.formData.set('items[' + index + '][quantity]', item.quantity);
        });
      };
      this.form?.addEventListener('formdata', this.onFormData);
      this.activate(this.buttons[Number(this.dataset.preselected)-1] || this.buttons[0]);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('formdata', this.onFormData);
      this.ready = false;
    }
    activate(button) {
      if (!button || button.disabled) return;
      this.activeButton = button;
      this.buttons.forEach(item => {
        const active = item === button;
        item.classList.toggle('tiered-option--active', active);
        item.setAttribute('aria-pressed', String(active));
        const panel = item.parentElement.querySelector('[data-bundle-picks]');
        if (panel) panel.hidden = !active;
      });
      const quantity = this.querySelector('input[name="quantity"]');
      if (quantity) quantity.value = button.dataset.quantity;
      this.update();
    }
    selectedVariants(button) {
      return Array.from(button.parentElement.querySelectorAll('.celociel-bundle-row')).map(row => {
        const choices = Array.from(row.querySelectorAll('select')).map(select => select.value);
        return this.variants.find(variant => variant.options.every((option,index) => option === choices[index]));
      });
    }
    getItems() {
      const selected = this.selectedVariants(this.activeButton);
      if (!selected.length || selected.some(variant => !variant?.available)) return [];
      const items = new Map();
      selected.forEach(variant => items.set(variant.id, (items.get(variant.id) || 0) + 1));
      return Array.from(items, ([id,quantity]) => ({id,quantity}));
    }
    update() {
      this.buttons.forEach(button => {
        const variants = this.selectedVariants(button);
        if (!variants.length) return;
        const rows = button.parentElement.querySelectorAll('.celociel-bundle-row');
        variants.forEach((variant,index) => {
          rows[index].querySelector('.celociel-bundle-stock').textContent = variant?.available ? '' : this.dataset.unavailable;
        });
        if (variants.some(variant => !variant)) return;
        const total = variants.reduce((sum,variant) => sum + variant.price, 0);
        const discount = Number(button.dataset.discount) || 0;
        const final = variants.reduce((sum,variant) => sum + variant.price - Math.floor(variant.price * discount / 100), 0);
        const compare = button.querySelector('.tiered-option__compare-price');
        const price = button.querySelector('.tiered-option__final-price');
        const perUnit = button.querySelector('.tiered-option__per-unit');
        if (compare) compare.textContent = this.money.format(total / 100);
        if (price) price.textContent = this.money.format(final / 100);
        if (perUnit && discount) perUnit.textContent = this.money.format(final / variants.length / 100) + ' ' + this.dataset.perTank;
      });
      const valid = this.getItems().length > 0;
      if (this.submit) {
        this.submit.disabled = !valid;
        this.submit.setAttribute('aria-disabled', String(!valid));
      }
    }
  });
}

